import anklePatrolAxios from '../../../services/config/axiosClient'
import { commonResponse } from '../../Auth/types/APIResponseType'
import { settignAPIRoutes } from './apiRoutes'
import {
  ChangeProfilePasswordPayload,
  CreateContentPayload,
  CreateHelpPayload,
  SendBroadcastPayload,
  UpdateContent,
  UpdateHelp,
} from './types/APIRequestType'
import {
  CreateContent,
  CreateHelpResponse,
  GetProfileDataResponse,
  HelpData,
  SendBroadcastResponse,
} from './types/APIResponseType'

export const helpPoint = (): Promise<commonResponse<HelpData>> =>
  anklePatrolAxios.get(settignAPIRoutes.help)
export const createHelp = (
  payload: CreateHelpPayload,
): Promise<commonResponse<CreateHelpResponse>> =>
  anklePatrolAxios.post(settignAPIRoutes.createHelp, payload)

export const updateHelp = (payload: UpdateHelp) =>
  anklePatrolAxios.put(settignAPIRoutes.updateHelp, payload)

export const deleteHelp = (payload: {
  helpId: string
}): Promise<commonResponse<null>> =>
  anklePatrolAxios.delete(settignAPIRoutes.deleteHelp, { data: payload })

export const createContent = (
  payload: CreateContentPayload,
): Promise<commonResponse<CreateContent>> =>
  anklePatrolAxios.post(settignAPIRoutes.createContent, payload)

export const getContent = (payload: { type: string; role: string }) =>
  anklePatrolAxios.post(settignAPIRoutes.getContent, payload)

export const updateContent = (payload: UpdateContent) =>
  anklePatrolAxios.put(settignAPIRoutes.updateContent, payload)

export const getProfile = (): Promise<commonResponse<GetProfileDataResponse>> =>
  anklePatrolAxios.get(settignAPIRoutes.getProfile)

export const updateProfile = (payload: FormData) =>
  anklePatrolAxios.put(settignAPIRoutes.updateProfile, payload)

export const changePassword = (
  payload: ChangeProfilePasswordPayload,
): Promise<commonResponse<null>> =>
  anklePatrolAxios.post(settignAPIRoutes.changePassword, payload)

export const sendBroadcast = (
  payload: SendBroadcastPayload,
): Promise<commonResponse<SendBroadcastResponse>> =>
  anklePatrolAxios.post(settignAPIRoutes.sendBroadcast, payload)
